<template>
    <div class="registration">
        <b-row>
            <b-col cols="1">
                <i class="fas fa-fw mr-3" :class="{'fa-user-check': registration.my247ed_id, 'fa-user-times': !registration.my247ed_id}"></i>
                <i class="fas fa-fw" :class="{'fa-file-check': registration.cert_number, 'fa-file-times': !registration.cert_number}"></i>
            </b-col>
            <b-col cols="6">
                <h6 class="mb-1">
                    {{registration.last_name}}, {{registration.first_name}}
                </h6>
                <div class="date">{{registration.created_at | moment('MMM D, YYYY')}} ({{registration.code}})</div>
                <div class="date">{{registration.email_address}}</div>
                <div class="date"><span v-if="registration.district">{{registration.district.name}}</span><span v-if="registration.district && registration.school">, </span><span v-if="registration.school">{{registration.school.SchoolName}}</span></div>
            </b-col>
            <b-col class="text-right">
                <a :href="'https://www.my247ed.com/admin/users/details.php?id=' + registration.my247ed_account.id" target="_blank" v-if="registration.my247ed_account && registration.my247ed_account.id">
                    <b-badge variant="primary" class="mr-2">
                        <i class="fas fa-user mr-2"></i>{{registration.my247ed_account.firstname}} {{registration.my247ed_account.lastname}} ({{registration.my247ed_account.id}})
                    </b-badge>
                </a>
                <a :href="'https://www.my247ed.com/functions/print.php?certs=' + registration.cert_number" target="_blank" v-if="registration.cert_number">
                    <b-badge variant="primary">
                        <i class="fas fa-file-invoice mr-2"></i>{{registration.cert_number}}
                    </b-badge>
                </a>
            </b-col>
        </b-row>
        <b-row class="mt-2" v-if="registration.cert_info">
            <b-col cols="1" class="text-right"><i class="far fa-info-circle"></i></b-col>
            <b-col>
                <div class="meta"><strong>Degree</strong>{{registration.cert_info.hdeg}}</div>
                <div class="meta"><strong>Exp</strong>{{registration.cert_info.years_teaching}}</div>
                <div class="meta"><strong>Credits</strong>{{registration.cert_info.credits}}</div>
                <div class="meta"><strong>Salary</strong>{{registration.cert_info.certbase | currency}}</div>
                <div class="meta"><strong>Duty</strong>{{registration.cert_info.duty}}</div>
                <div class="meta" v-if="registration.cert_info.totalhours"><strong>Hours</strong>{{registration.cert_info.totalhours}}</div>
                <div class="meta" v-if="registration.cert_info.unearned"><strong>Un-Earned</strong>{{registration.cert_info.unearned}}</div>
                <div class="meta"><strong>Yr</strong>{{registration.cert_info.yr}}</div>
            </b-col>
        </b-row>

        <b-row class="mt-2 mb-2">
            <b-col cols="1"></b-col>
            <b-col>
                <b-button variant="info" size="sm" @click="suggestCerts(registration.id)" v-if="!registration.cert_number" class="mr-2"><i class="fas fa-lightbulb mr-2"></i>Suggest Cert</b-button>
                <b-button variant="info" size="sm" @click="suggestIds(registration.id)" v-if="!registration.my247ed_id"><i class="fas fa-lightbulb mr-2"></i>Suggest ID</b-button>
            </b-col>
        </b-row>

        <div v-if="certSuggest" class="mt-4">
            <b-row v-if="certSuggest.obvious">
                <b-col cols="1"></b-col>
                <b-col>
                    <b-row class="guess">
                        <b-col>
                            <div><i class="fas fa-arrow-right mr-2"></i>Based on my247ed.com user account the cert number is <strong>{{certSuggest.obvious}}</strong>.</div>
                        </b-col>
                        <b-col cols="4" class="text-right">
                            <b-button variant="success" @click="saveCert(certSuggest.obvious)"><i class="far fa-check mr-2"></i>Use {{certSuggest.obvious}}</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row v-for="guess in certSuggest.guesses">
                <b-col cols="1"></b-col>
                <b-col>
                    <b-row class="guess">
                        <b-col>
                            <h6>{{guess.LastName}}, {{guess.FirstName}} {{guess.MiddleName}}</h6>
                            <div class="date">{{guess.district}}, {{guess.school_name}}</div>
                            <div class="date">{{guess.SchoolYear}}, {{guess.duty}}</div>
                        </b-col>
                        <b-col cols="2" class="text-right">
                            <b-button variant="success" size="sm" @click="saveCert(guess.cert)"><i class="fas fa-check mr-2"></i>Use {{guess.cert}}</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                    <b-row class="guess">
                        <b-col>
                            <b-input-group>
                                <b-input placeholder="Cert Number" v-model="manualCert"/>
                                <b-input-group-append>
                                    <b-button variant="success" @click="saveCert(manualCert)"><i class="far fa-check mr-2"></i>Set Cert</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
        <div v-if="idSuggest" class="mt-4">
            <b-row v-if="idSuggest.obvious">
                <b-col cols="1"></b-col>
                <b-col>
                    <b-row class="guess">
                        <b-col>
                            <div><i class="fas fa-arrow-right mr-2"></i>Based on the cert number the my247ed.com user account number is <strong>{{idSuggest.obvious.id}}</strong>.</div>
                        </b-col>
                        <b-col cols="4" class="text-right">
                            <b-button variant="success" @click="saveId(idSuggest.obvious.id)"><i class="far fa-check mr-2"></i>Use {{idSuggest.obvious.id}}</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row v-for="guess in idSuggest.guesses">
                <b-col cols="1"></b-col>
                <b-col>
                    <b-row class="guess">
                        <b-col>
                            <h6>{{guess.lastname}}, {{guess.firstname}}</h6>
                            <div class="date">{{guess.cert_number}}</div>
                            <div class="date">{{guess.email}}<span v-if="guess.email2">, </span>{{guess.email2}}</div>
                            <div class="date">{{guess.district}}<span v-if="guess.district && guess.school">, </span>{{guess.school}}</div>
                        </b-col>
                        <b-col cols="4" class="text-right">
                            <b-button variant="success" size="sm" :href="'https://www.my247ed.com/admin/users/details.php?id=' + guess.id" target="_blank" class="mr-2"><i class="fas fa-user mr-2"></i>View</b-button>
                            <b-button variant="success" size="sm" @click="saveId(guess.id)"><i class="fas fa-check mr-2"></i>Use {{guess.id}}</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="1"></b-col>
                <b-col>
                    <b-row class="guess">
                        <b-col>
                            <b-input-group>
                                <b-input placeholder="my247ed.com User ID" v-model="manualId"/>
                                <b-input-group-append>
                                    <b-button variant="success" @click="saveId(manualId)"><i class="far fa-check mr-2"></i>Set ID</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "AdminRegistrationRow",
        props: ['conference', 'registration'],
        data: function () {
            return {
                manualCert: '',
                certSuggest: null,
                idSuggest: null,
                manualId: ''
            }
        },
        methods: {
            ...mapActions(['getCerts', 'getIds', 'updateCert']),

            suggestCerts(id) {
                this.getCerts(id).then(results => {
                    this.certSuggest = results;
                });
            },
            suggestIds(id) {
                this.getIds(id).then(results => {
                    this.idSuggest = results;
                });
            },

            saveCert(cert) {
                this.certSuggest = null;
                this.manualCert = '';

                this.updateCert({id: this.registration.id, data: {cert_number: cert, my247ed_id: this.registration.my247ed_id}}).then(() => {
                    this.registration.cert_number = cert;
                });
            },

            saveId(id) {
                this.idSuggest = null;
                this.manualId = '';

                this.updateCert({id: this.registration.id, data: {cert_number: this.registration.cert_number, my247ed_id: id}}).then(data => {
                    this.registration.my247ed_id = id;
                    this.registration.my247ed_account = data;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .registration {
        padding: 1rem;
        margin-bottom: 0.2rem;

        .date {
            font-size: 0.8rem;
            color: #333;
        }

        .fa-user-check, .fa-file-check {
            color: $success !important;
        }

        .fa-file-times, .fa-user-times {
            color: $warning !important;
        }
    }

    .guess {
        border: 1px solid #ccc;
        border-radius: 0.3rem;
        padding: 1rem 0;
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .meta {
        display: inline-block;
        font-size: 0.9rem;
        margin-right: 1.5rem;

        strong {
            margin-right: 0.3rem;
        }
    }

</style>